// ZIP3 (SCF) prefix → [lat,lng] centroids, from the GeoNames US postal dataset
// (download.geonames.org/export/zip/US.zip), averaged per 3-digit prefix.
// Used to centroid a market from its ZIP list when /location/places sends no coords.
export default {
  "160": [40.936, -79.885],
  "161": [41.151, -80.348],
  "162": [41.019, -79.386],
  "163": [41.576, -79.552],
  "164": [41.891, -80.028],
  "165": [42.134, -80.072],
  "660": [38.924, -95.109],
  "166": [40.482, -78.352],
  "661": [39.103, -94.695],
  "210": [39.368, -76.572],
  "167": [41.809, -78.500],
  "662": [38.963, -94.710],
  "211": [39.386, -76.645],
  "168": [40.938, -77.995],
  "212": [39.312, -76.613],
  "169": [41.829, -77.265],
  "664": [39.388, -96.061],
  "665": [39.327, -96.108],
  "214": [38.991, -76.523],
  "666": [39.043, -95.705],
  "710": [32.489, -93.479],
  "215": [39.589, -78.972],
  "667": [37.596, -95.093],
  "711": [32.553, -93.746],
  "216": [38.861, -76.050],
  "668": [38.355, -96.377],
  "712": [32.555, -92.004],
  "217": [39.496, -77.481],
  "669": [39.782, -97.710],
  "713": [31.317, -92.018],
  "218": [38.271, -75.610],
  "714": [31.548, -92.857],
  "219": [39.566, -75.949],
  "716": [33.702, -91.763],
  "717": [33.507, -92.808],
  "718": [33.673, -93.826],
  "719": [34.397, -93.521],
  "170": [40.401, -77.036],
  "171": [40.278, -76.863],
  "172": [40.000, -77.766],
  "173": [39.899, -76.873],
  "174": [39.965, -76.697],
  "175": [40.055, -76.238],
  "670": [37.555, -97.596],
  "220": [38.831, -77.253],
  "176": [40.041, -76.309],
  "671": [37.551, -97.670],
  "221": [38.789, -77.252],
  "177": [41.288, -77.120],
  "672": [37.692, -97.341],
  "222": [38.875, -77.097],
  "178": [40.882, -76.805],
  "673": [37.192, -95.759],
  "223": [38.797, -77.087],
  "179": [40.708, -76.276],
  "674": [38.939, -97.742],
  "224": [38.125, -77.067],
  "675": [38.231, -98.828],
  "225": [38.046, -77.005],
  "720": [34.959, -91.988],
  "676": [39.319, -99.398],
  "226": [39.028, -78.220],
  "721": [34.900, -92.099],
  "677": [39.342, -101.078],
  "227": [38.472, -78.057],
  "722": [34.759, -92.345],
  "678": [37.798, -100.661],
  "228": [38.559, -78.818],
  "723": [35.114, -90.523],
  "679": [37.137, -101.384],
  "229": [38.036, -78.575],
  "724": [36.034, -90.741],
  "725": [36.001, -91.786],
  "726": [36.181, -92.866],
  "727": [36.172, -94.166],
  "728": [35.280, -93.388],
  "729": [35.342, -94.236],
  "180": [40.633, -75.457],
  "181": [40.602, -75.510],
  "182": [40.915, -75.950],
  "183": [41.080, -75.238],
  "184": [41.563, -75.408],
  "185": [41.404, -75.667],
  "680": [41.472, -96.418],
  "230": [37.585, -77.126],
  "186": [41.312, -76.055],
  "681": [41.249, -96.004],
  "231": [37.546, -77.036],
  "187": [41.255, -75.885],
  "232": [37.520, -77.464],
  "188": [41.821, -76.080],
  "683": [40.469, -96.829],
  "233": [37.369, -75.958],
  "189": [40.350, -75.179],
  "684": [40.539, -96.614],
  "234": [37.240, -76.002],
  "685": [40.818, -96.689],
  "235": [36.897, -76.258],
  "730": [35.315, -97.737],
  "686": [41.476, -97.511],
  "236": [37.107, -76.441],
  "731": [35.495, -97.489],
  "687": [42.393, -97.723],
  "237": [36.840, -76.344],
  "688": [41.142, -98.920],
  "238": [36.969, -77.427],
  "733": [30.326, -97.771],
  "689": [40.348, -98.815],
  "239": [37.016, -78.415],
  "734": [34.234, -97.171],
  "735": [34.525, -98.723],
  "736": [35.504, -99.283],
  "737": [36.382, -98.115],
  "738": [36.463, -99.473],
  "739": [36.733, -101.531],
  "190": [40.010, -75.221],
  "191": [39.991, -75.144],
  "192": [40.002, -75.118],
  "193": [39.926, -75.717],
  "194": [40.174, -75.426],
  "195": [40.409, -75.886],
  "690": [40.334, -100.868],
  "240": [37.196, -80.044],
  "196": [40.348, -75.947],
  "691": [41.277, -101.596],
  "241": [37.080, -80.147],
  "692": [42.751, -100.609],
  "197": [39.628, -75.639],
  "242": [36.835, -82.471],
  "693": [42.157, -103.034],
  "198": [39.702, -75.569],
  "243": [36.842, -81.135],
  "199": [38.875, -75.436],
  "244": [38.081, -79.358],
  "245": [37.148, -79.129],
  "740": [36.256, -96.180],
  "246": [37.202, -81.798],
  "741": [36.138, -95.970],
  "247": [37.398, -81.218],
  "248": [37.469, -81.640],
  "743": [36.543, -94.969],
  "249": [37.847, -80.428],
  "744": [35.646, -95.440],
  "745": [34.668, -95.693],
  "746": [36.694, -97.153],
  "747": [34.013, -95.584],
  "748": [35.173, -96.692],
  "749": [35.212, -94.698],
  "250": [38.205, -81.493],
  "251": [38.232, -81.525],
  "252": [38.616, -81.557],
  "253": [38.343, -81.618],
  "254": [39.401, -78.041],
  "255": [38.292, -82.174],
  "750": [33.037, -96.787],
  "256": [37.761, -82.050],
  "751": [32.555, -96.471],
  "300": [33.879, -84.185],
  "257": [38.415, -82.342],
  "752": [32.801, -96.793],
  "301": [34.022, -84.867],
  "258": [37.792, -81.213],
  "753": [32.768, -96.777],
  "302": [33.328, -84.475],
  "259": [37.783, -81.069],
  "754": [33.361, -95.807],
  "303": [33.809, -84.387],
  "755": [33.278, -94.337],
  "304": [32.415, -82.120],
  "756": [32.459, -94.636],
  "800": [39.795, -104.916],
  "305": [34.516, -83.724],
  "757": [32.257, -95.330],
  "801": [39.513, -104.837],
  "306": [33.889, -83.269],
  "758": [31.504, -95.699],
  "802": [39.741, -104.982],
  "307": [34.761, -85.090],
  "759": [31.300, -94.389],
  "803": [40.037, -105.303],
  "308": [33.343, -82.356],
  "804": [39.834, -105.917],
  "309": [33.433, -82.075],
  "805": [40.414, -105.130],
  "806": [40.326, -104.634],
  "807": [40.482, -103.086],
  "808": [39.084, -103.835],
  "809": [38.844, -104.768],
  "260": [40.172, -80.627],
  "261": [39.221, -81.290],
  "262": [38.771, -80.060],
  "263": [39.202, -80.523],
  "264": [39.257, -80.402],
  "265": [39.573, -80.109],
  "760": [32.669, -97.343],
  "266": [38.461, -80.807],
  "761": [32.764, -97.311],
  "310": [32.597, -83.461],
  "267": [39.359, -78.963],
  "762": [33.406, -97.278],
  "311": [33.834, -84.395],
  "268": [38.948, -79.016],
  "763": [33.803, -98.747],
  "312": [32.819, -83.665],
  "764": [32.525, -98.460],
  "313": [31.915, -81.420],
  "765": [31.091, -97.547],
  "314": [32.025, -81.098],
  "766": [31.755, -97.035],
  "810": [37.914, -103.808],
  "315": [31.342, -82.130],
  "767": [31.552, -97.167],
  "811": [37.443, -106.203],
  "316": [30.987, -83.206],
  "768": [31.330, -99.326],
  "812": [38.509, -106.110],
  "317": [31.459, -83.870],
  "769": [31.419, -100.573],
  "813": [37.429, -108.429],
  "318": [32.518, -84.721],
  "814": [38.434, -108.010],
  "319": [32.484, -84.931],
  "815": [39.060, -108.610],
  "816": [39.697, -107.377],
  "270": [36.254, -80.397],
  "271": [36.066, -80.241],
  "272": [35.891, -79.695],
  "273": [35.942, -79.641],
  "274": [36.079, -79.804],
  "770": [29.776, -95.414],
  "275": [35.878, -78.571],
  "276": [35.809, -78.634],
  "320": [30.164, -82.124],
  "772": [29.825, -95.425],
  "277": [36.020, -78.891],
  "321": [29.308, -81.428],
  "773": [30.350, -95.342],
  "278": [35.908, -77.433],
  "322": [30.307, -81.630],
  "774": [29.480, -95.938],
  "279": [36.103, -76.194],
  "323": [30.336, -84.267],
  "775": [29.582, -95.044],
  "324": [30.496, -85.567],
  "820": [41.287, -105.058],
  "776": [30.090, -94.128],
  "325": [30.536, -86.992],
  "821": [44.796, -110.614],
  "777": [30.090, -94.144],
  "326": [29.594, -82.456],
  "822": [42.304, -104.546],
  "778": [30.667, -96.336],
  "327": [28.778, -81.310],
  "823": [41.646, -107.147],
  "779": [28.897, -96.924],
  "328": [28.518, -81.307],
  "824": [44.454, -108.377],
  "329": [28.026, -80.591],
  "825": [43.137, -108.776],
  "826": [42.992, -106.602],
  "827": [44.345, -104.837],
  "828": [44.702, -106.844],
  "829": [41.741, -109.866],
  "280": [35.368, -81.015],
  "281": [35.292, -80.770],
  "282": [35.229, -80.824],
  "283": [34.984, -78.988],
  "284": [34.297, -78.199],
  "780": [28.953, -98.883],
  "285": [35.006, -77.116],
  "781": [29.199, -97.981],
  "286": [36.069, -81.372],
  "330": [25.775, -80.409],
  "782": [29.464, -98.498],
  "287": [35.443, -82.684],
  "331": [25.771, -80.262],
  "783": [27.721, -97.841],
  "288": [35.600, -82.544],
  "332": [25.774, -80.199],
  "784": [27.762, -97.435],
  "289": [35.077, -83.945],
  "333": [26.128, -80.213],
  "785": [26.272, -98.051],
  "334": [26.607, -80.175],
  "830": [43.614, -110.721],
  "786": [30.278, -97.906],
  "335": [28.094, -82.270],
  "831": [42.538, -110.724],
  "787": [30.309, -97.762],
  "336": [27.943, -82.462],
  "788": [29.261, -100.110],
  "337": [27.865, -82.730],
  "832": [42.912, -112.379],
  "789": [29.925, -96.817],
  "338": [27.895, -81.709],
  "833": [42.825, -114.261],
  "339": [26.694, -81.900],
  "834": [44.021, -112.129],
  "835": [46.167, -116.312],
  "836": [43.884, -116.338],
  "837": [43.546, -116.230],
  "838": [47.679, -116.556],
  "290": [33.966, -80.818],
  "291": [33.891, -80.880],
  "292": [34.016, -81.008],
  "293": [34.864, -81.905],
  "294": [32.964, -80.100],
  "790": [35.341, -101.535],
  "295": [34.063, -79.408],
  "340": [5.113, -75.388],
  "791": [35.253, -101.866],
  "296": [34.677, -82.569],
  "792": [34.272, -100.669],
  "297": [34.884, -80.947],
  "341": [26.144, -81.658],
  "793": [33.508, -102.179],
  "298": [33.524, -81.763],
  "342": [27.310, -82.424],
  "794": [33.574, -101.871],
  "299": [32.540, -80.902],
  "795": [32.654, -100.200],
  "344": [29.016, -82.316],
  "840": [40.628, -111.427],
  "796": [32.444, -99.747],
  "841": [40.709, -111.895],
  "797": [31.720, -102.466],
  "346": [28.302, -82.611],
  "842": [41.250, -111.982],
  "798": [30.773, -104.758],
  "347": [28.496, -81.607],
  "843": [41.712, -112.087],
  "799": [31.758, -106.397],
  "844": [41.238, -111.962],
  "349": [27.303, -80.388],
  "845": [38.676, -110.276],
  "846": [39.552, -111.865],
  "847": [37.786, -112.717],
  "350": [33.573, -86.702],
  "351": [33.495, -86.632],
  "352": [33.516, -86.844],
  "354": [33.137, -87.727],
  "850": [33.497, -112.080],
  "355": [33.968, -87.644],
  "851": [33.066, -111.518],
  "356": [34.702, -87.299],
  "400": [38.123, -85.330],
  "852": [33.439, -111.824],
  "357": [34.738, -86.354],
  "401": [37.869, -86.132],
  "853": [33.471, -112.888],
  "358": [34.725, -86.579],
  "402": [38.208, -85.696],
  "359": [34.281, -85.950],
  "403": [38.062, -84.181],
  "855": [33.331, -110.322],
  "404": [37.512, -84.428],
  "900": [34.034, -118.284],
  "856": [31.831, -110.470],
  "405": [38.030, -84.485],
  "901": [34.052, -118.250],
  "857": [32.231, -110.944],
  "406": [38.226, -84.874],
  "902": [33.939, -118.353],
  "407": [37.000, -84.075],
  "903": [33.914, -118.336],
  "859": [34.209, -109.903],
  "408": [36.895, -83.279],
  "904": [34.021, -118.489],
  "409": [36.932, -83.703],
  "905": [33.811, -118.313],
  "906": [33.927, -118.034],
  "907": [33.798, -118.186],
  "908": [33.790, -118.196],
  "360": [32.156, -86.139],
  "361": [32.303, -86.245],
  "362": [33.581, -85.703],
  "363": [31.289, -85.547],
  "364": [31.408, -87.068],
  "860": [35.698, -111.217],
  "365": [30.860, -87.942],
  "366": [30.683, -88.123],
  "410": [38.786, -84.401],
  "367": [32.318, -87.378],
  "411": [38.365, -82.949],
  "863": [34.688, -112.288],
  "368": [32.573, -85.328],
  "412": [37.863, -82.712],
  "864": [35.221, -114.177],
  "369": [32.142, -88.249],
  "413": [37.567, -83.476],
  "865": [35.966, -109.453],
  "414": [37.854, -83.174],
  "910": [34.180, -118.124],
  "415": [37.446, -82.371],
  "911": [34.147, -118.139],
  "416": [37.504, -82.738],
  "912": [34.162, -118.253],
  "417": [37.240, -83.224],
  "913": [34.261, -118.576],
  "418": [37.223, -82.861],
  "914": [34.180, -118.456],
  "915": [34.181, -118.313],
  "916": [34.145, -118.377],
  "917": [34.070, -117.849],
  "918": [34.091, -118.130],
  "919": [32.700, -116.865],
  "370": [36.122, -86.847],
  "371": [36.060, -86.709],
  "372": [36.166, -86.786],
  "373": [35.271, -85.349],
  "374": [35.041, -85.284],
  "375": [35.159, -90.020],
  "870": [35.222, -106.768],
  "376": [36.383, -82.356],
  "871": [35.084, -106.646],
  "420": [36.904, -88.582],
  "377": [36.161, -83.873],
  "421": [36.886, -86.064],
  "378": [36.104, -83.778],
  "873": [35.502, -108.563],
  "422": [36.958, -86.990],
  "379": [35.972, -83.965],
  "874": [36.714, -108.249],
  "423": [37.493, -87.033],
  "875": [36.104, -105.917],
  "424": [37.513, -87.657],
  "876": [32.990, -106.970],
  "920": [33.096, -117.128],
  "425": [37.143, -84.695],
  "877": [36.032, -104.953],
  "921": [32.757, -117.139],
  "426": [36.778, -84.695],
  "878": [34.052, -107.757],
  "922": [33.604, -115.944],
  "427": [37.351, -85.750],
  "879": [32.964, -107.302],
  "923": [34.473, -117.004],
  "924": [34.119, -117.296],
  "925": [33.786, -117.206],
  "926": [33.630, -117.793],
  "927": [33.736, -117.865],
  "928": [33.842, -117.839],
  "380": [35.487, -89.473],
  "381": [35.158, -89.962],
  "382": [36.283, -88.736],
  "383": [35.608, -88.562],
  "384": [35.297, -87.297],
  "385": [36.188, -85.418],
  "880": [32.434, -107.523],
  "430": [40.164, -82.928],
  "881": [34.201, -103.491],
  "386": [34.593, -89.829],
  "431": [39.704, -82.901],
  "882": [32.807, -103.891],
  "387": [33.568, -90.812],
  "432": [39.990, -82.991],
  "883": [33.253, -105.634],
  "388": [34.309, -88.659],
  "433": [40.532, -83.350],
  "884": [35.656, -103.790],
  "389": [33.773, -89.951],
  "885": [31.695, -106.300],
  "434": [41.467, -83.300],
  "435": [41.462, -84.133],
  "930": [34.277, -119.107],
  "436": [41.673, -83.527],
  "931": [34.419, -119.746],
  "437": [39.856, -81.696],
  "932": [35.901, -119.217],
  "438": [40.265, -81.851],
  "889": [36.125, -114.896],
  "933": [35.335, -118.986],
  "439": [40.220, -80.854],
  "934": [35.199, -120.589],
  "935": [35.524, -118.100],
  "936": [36.848, -119.704],
  "937": [36.754, -119.693],
  "938": [36.746, -119.640],
  "939": [36.514, -121.628],
  "390": [32.453, -90.156],
  "391": [32.362, -90.247],
  "392": [32.300, -90.178],
  "393": [32.374, -88.816],
  "394": [31.330, -89.302],
  "890": [36.483, -115.319],
  "395": [30.442, -89.005],
  "440": [41.548, -81.389],
  "891": [36.161, -115.185],
  "396": [31.351, -90.543],
  "441": [41.491, -81.668],
  "397": [33.529, -88.832],
  "442": [41.116, -81.581],
  "893": [39.235, -115.280],
  "398": [31.308, -84.648],
  "443": [41.081, -81.531],
  "894": [39.671, -119.105],
  "399": [33.891, -84.075],
  "444": [41.094, -80.749],
  "895": [39.536, -119.815],
  "445": [41.078, -80.680],
  "940": [37.471, -122.268],
  "446": [40.671, -81.468],
  "897": [39.165, -119.776],
  "941": [37.769, -122.424],
  "447": [40.813, -81.378],
  "898": [41.071, -115.544],
  "942": [38.582, -121.494],
  "448": [41.031, -82.763],
  "943": [37.439, -122.150],
  "449": [40.761, -82.517],
  "944": [37.550, -122.309],
  "945": [37.940, -122.061],
  "946": [37.801, -122.243],
  "947": [37.873, -122.274],
  "948": [37.947, -122.333],
  "949": [38.078, -122.642],
  "450": [39.392, -84.494],
  "451": [39.107, -83.926],
  "452": [39.171, -84.504],
  "453": [39.993, -84.278],
  "454": [39.747, -84.200],
  "455": [39.928, -83.808],
  "950": [37.110, -121.875],
  "456": [38.934, -82.818],
  "005": [40.815, -73.045],
  "951": [37.321, -121.875],
  "500": [41.704, -93.777],
  "457": [39.347, -81.806],
  "952": [38.090, -121.001],
  "501": [41.605, -93.465],
  "458": [40.826, -84.190],
  "953": [37.633, -120.693],
  "502": [41.678, -93.559],
  "459": [39.167, -84.538],
  "954": [38.847, -123.037],
  "503": [41.646, -93.599],
  "955": [40.734, -123.927],
  "504": [43.164, -93.344],
  "956": [38.636, -121.275],
  "505": [42.745, -94.444],
  "957": [38.852, -120.968],
  "506": [42.630, -92.453],
  "958": [38.583, -121.444],
  "507": [42.482, -92.324],
  "959": [39.495, -121.527],
  "508": [40.962, -94.547],
  "509": [41.655, -93.581],
  "460": [40.147, -86.035],
  "461": [39.654, -86.162],
  "010": [42.265, -72.572],
  "462": [39.800, -86.136],
  "011": [42.124, -72.571],
  "463": [41.440, -87.161],
  "012": [42.347, -73.227],
  "464": [41.560, -87.337],
  "013": [42.594, -72.576],
  "960": [40.863, -122.268],
  "465": [41.456, -86.054],
  "014": [42.584, -71.767],
  "961": [39.898, -120.252],
  "510": [42.600, -95.909],
  "466": [41.664, -86.264],
  "015": [42.215, -71.828],
  "962": [36.300, 127.596],
  "511": [42.482, -96.389],
  "467": [41.171, -85.196],
  "016": [42.279, -71.828],
  "963": [30.355, 134.369],
  "512": [43.265, -96.031],
  "468": [41.090, -85.100],
  "017": [42.351, -71.454],
  "964": [15.031, 119.649],
  "513": [43.248, -95.131],
  "469": [40.723, -86.100],
  "018": [42.625, -71.196],
  "965": [9.055, 55.409],
  "514": [42.093, -95.068],
  "019": [42.603, -70.895],
  "515": [41.451, -95.556],
  "967": [20.812, -157.047],
  "516": [40.730, -95.359],
  "968": [21.288, -151.620],
  "969": [7.949, 169.487],
  "470": [39.157, -85.067],
  "471": [38.377, -85.968],
  "020": [42.152, -71.044],
  "472": [39.064, -85.749],
  "021": [42.334, -71.067],
  "473": [40.055, -85.209],
  "022": [42.349, -71.024],
  "474": [39.045, -86.672],
  "023": [42.012, -70.888],
  "970": [45.445, -122.267],
  "475": [38.414, -86.997],
  "024": [42.359, -71.216],
  "971": [45.534, -123.492],
  "520": [42.479, -90.950],
  "476": [38.151, -87.455],
  "025": [41.581, -70.546],
  "972": [45.519, -122.664],
  "521": [43.155, -91.728],
  "477": [37.996, -87.570],
  "026": [41.732, -70.171],
  "973": [44.760, -123.181],
  "522": [41.888, -91.747],
  "478": [39.462, -87.323],
  "027": [41.758, -71.081],
  "028": [41.674, -71.524],
  "974": [43.557, -123.460],
  "523": [41.903, -91.731],
  "479": [40.425, -87.061],
  "029": [41.819, -71.432],
  "975": [42.376, -123.106],
  "524": [42.037, -91.636],
  "976": [42.425, -121.221],
  "525": [40.969, -92.428],
  "977": [43.857, -120.612],
  "526": [40.872, -91.450],
  "978": [45.202, -118.621],
  "527": [41.661, -90.738],
  "979": [43.876, -117.545],
  "528": [41.565, -90.592],
  "480": [42.674, -82.923],
  "030": [42.882, -71.483],
  "481": [42.221, -83.501],
  "031": [42.992, -71.459],
  "482": [42.346, -83.100],
  "032": [43.516, -71.646],
  "483": [42.627, -83.319],
  "033": [43.247, -71.563],
  "484": [43.244, -83.288],
  "980": [47.552, -122.158],
  "034": [42.914, -72.203],
  "485": [43.011, -83.706],
  "530": [43.454, -88.212],
  "981": [47.604, -122.334],
  "035": [44.494, -71.483],
  "486": [43.805, -84.281],
  "531": [42.738, -88.224],
  "982": [48.362, -122.311],
  "036": [43.167, -72.344],
  "487": [43.919, -83.575],
  "532": [43.048, -87.951],
  "983": [47.443, -122.670],
  "037": [43.698, -72.151],
  "488": [43.030, -84.686],
  "984": [47.214, -122.456],
  "038": [43.376, -71.044],
  "489": [42.724, -84.571],
  "534": [42.731, -87.777],
  "985": [46.935, -123.221],
  "039": [43.190, -70.706],
  "535": [42.945, -89.605],
  "986": [45.920, -122.515],
  "537": [43.072, -89.402],
  "988": [47.854, -119.902],
  "538": [42.818, -90.748],
  "989": [46.660, -120.539],
  "539": [43.612, -89.525],
  "490": [42.219, -85.586],
  "040": [43.733, -70.512],
  "491": [41.889, -86.435],
  "041": [43.668, -70.247],
  "492": [42.046, -84.344],
  "042": [44.313, -70.374],
  "493": [43.207, -85.545],
  "043": [44.301, -69.780],
  "494": [43.230, -86.125],
  "990": [47.622, -117.449],
  "044": [45.122, -68.722],
  "495": [42.974, -85.620],
  "540": [45.066, -92.492],
  "991": [47.821, -117.985],
  "045": [43.945, -69.573],
  "496": [44.545, -85.634],
  "541": [44.862, -88.241],
  "992": [47.665, -117.399],
  "046": [44.538, -68.011],
  "497": [45.572, -84.541],
  "542": [44.548, -87.565],
  "993": [46.360, -118.979],
  "047": [46.712, -68.266],
  "498": [46.065, -87.198],
  "543": [44.493, -88.026],
  "994": [46.219, -117.051],
  "048": [44.108, -69.107],
  "499": [46.737, -88.826],
  "544": [44.870, -89.796],
  "995": [60.100, -155.202],
  "049": [44.758, -69.655],
  "545": [45.906, -89.878],
  "996": [60.231, -156.693],
  "546": [43.859, -90.913],
  "997": [65.720, -153.316],
  "547": [44.833, -91.592],
  "998": [58.020, -134.862],
  "548": [46.026, -91.634],
  "999": [55.656, -132.239],
  "549": [44.208, -88.826],
  "050": [43.822, -72.386],
  "051": [43.246, -72.614],
  "052": [43.033, -73.141],
  "053": [42.927, -72.739],
  "054": [44.590, -73.039],
  "550": [45.049, -93.019],
  "055": [42.647, -71.184],
  "056": [44.332, -72.574],
  "100": [40.762, -73.978],
  "551": [44.958, -93.103],
  "057": [43.658, -73.055],
  "101": [40.768, -73.977],
  "058": [44.668, -72.126],
  "102": [40.734, -73.998],
  "553": [44.983, -93.871],
  "059": [44.792, -71.651],
  "103": [40.587, -74.147],
  "554": [44.982, -93.296],
  "104": [40.849, -73.878],
  "555": [44.967, -93.609],
  "105": [41.195, -73.775],
  "556": [47.490, -91.008],
  "600": [42.222, -87.996],
  "106": [41.047, -73.765],
  "557": [47.179, -92.783],
  "601": [41.968, -88.214],
  "107": [40.947, -73.858],
  "558": [46.786, -92.127],
  "602": [42.047, -87.692],
  "108": [40.916, -73.789],
  "559": [43.905, -92.293],
  "603": [41.898, -87.819],
  "109": [41.261, -74.169],
  "604": [41.526, -87.910],
  "605": [41.736, -88.290],
  "606": [41.855, -87.676],
  "607": [41.948, -87.774],
  "608": [41.720, -87.707],
  "609": [40.824, -87.930],
  "060": [41.860, -72.791],
  "061": [41.777, -72.702],
  "062": [41.826, -72.089],
  "063": [41.495, -72.037],
  "064": [41.434, -72.782],
  "560": [43.998, -93.971],
  "065": [41.322, -72.930],
  "110": [40.754, -73.678],
  "561": [43.899, -95.660],
  "066": [41.193, -73.193],
  "111": [40.756, -73.931],
  "562": [45.023, -95.657],
  "067": [41.633, -73.160],
  "112": [40.652, -73.955],
  "563": [45.752, -94.603],
  "068": [41.213, -73.423],
  "113": [40.743, -73.838],
  "564": [46.577, -94.502],
  "069": [41.062, -73.539],
  "114": [40.686, -73.805],
  "565": [46.841, -96.126],
  "115": [40.708, -73.638],
  "566": [47.839, -94.448],
  "610": [42.205, -89.525],
  "116": [40.599, -73.821],
  "567": [48.428, -96.338],
  "611": [42.297, -89.097],
  "117": [40.803, -73.246],
  "612": [41.494, -90.357],
  "118": [40.770, -73.522],
  "569": [38.895, -77.036],
  "613": [41.343, -89.208],
  "119": [40.923, -72.552],
  "614": [40.839, -90.413],
  "615": [40.687, -89.697],
  "616": [40.720, -89.633],
  "617": [40.502, -88.923],
  "618": [40.104, -88.126],
  "619": [39.678, -88.217],
  "070": [40.759, -74.229],
  "071": [40.751, -74.196],
  "072": [40.666, -74.225],
  "073": [40.728, -74.068],
  "074": [41.045, -74.303],
  "570": [43.488, -97.009],
  "075": [40.941, -74.196],
  "571": [43.590, -96.751],
  "120": [42.686, -73.939],
  "076": [40.927, -74.020],
  "572": [45.034, -97.113],
  "121": [42.689, -73.929],
  "077": [40.310, -74.108],
  "573": [43.803, -98.400],
  "122": [42.659, -73.764],
  "078": [40.935, -74.760],
  "574": [45.352, -98.736],
  "123": [42.813, -73.948],
  "079": [40.744, -74.521],
  "575": [43.748, -100.424],
  "124": [42.083, -74.205],
  "576": [45.535, -101.371],
  "125": [41.764, -73.862],
  "620": [39.056, -89.999],
  "577": [44.092, -103.086],
  "126": [41.728, -73.815],
  "127": [41.688, -74.767],
  "622": [38.436, -89.796],
  "128": [43.494, -73.717],
  "623": [40.032, -91.057],
  "129": [44.566, -73.916],
  "624": [39.050, -88.210],
  "625": [39.708, -89.215],
  "626": [39.825, -89.992],
  "627": [39.776, -89.619],
  "628": [38.306, -88.675],
  "629": [37.553, -88.986],
  "080": [39.823, -74.985],
  "081": [39.932, -75.087],
  "082": [39.267, -74.682],
  "083": [39.428, -75.030],
  "084": [39.348, -74.466],
  "085": [40.277, -74.668],
  "580": [46.678, -97.305],
  "130": [42.981, -76.189],
  "086": [40.250, -74.719],
  "581": [46.870, -96.802],
  "131": [43.068, -76.269],
  "087": [39.983, -74.144],
  "582": [48.212, -97.606],
  "132": [43.048, -76.159],
  "088": [40.538, -74.629],
  "583": [48.364, -99.196],
  "133": [43.154, -75.229],
  "089": [40.480, -74.446],
  "584": [46.952, -99.018],
  "134": [43.112, -75.274],
  "585": [46.787, -100.904],
  "135": [43.100, -75.232],
  "586": [46.773, -102.904],
  "630": [38.448, -90.661],
  "136": [44.293, -75.529],
  "587": [48.357, -101.562],
  "631": [38.640, -90.286],
  "137": [42.252, -75.538],
  "588": [48.242, -103.511],
  "138": [42.341, -75.581],
  "633": [38.946, -91.009],
  "139": [42.113, -75.894],
  "634": [39.972, -91.781],
  "635": [40.199, -92.591],
  "636": [37.653, -90.624],
  "637": [37.327, -89.767],
  "638": [36.498, -89.786],
  "639": [36.841, -90.516],
  "090": [49.450, 9.167],
  "091": [49.592, 9.084],
  "092": [50.061, 9.115],
  "093": [50.231, 8.637],
  "094": [52.467, -1.264],
  "095": [19.906, -75.207],
  "590": [45.820, -108.668],
  "096": [37.461, 18.645],
  "140": [42.800, -78.632],
  "591": [45.797, -108.516],
  "097": [42.210, 12.058],
  "141": [42.820, -78.721],
  "592": [48.322, -105.302],
  "098": [28.044, 40.286],
  "142": [42.869, -78.845],
  "593": [46.312, -105.372],
  "143": [43.097, -79.027],
  "594": [47.736, -111.221],
  "144": [42.973, -77.613],
  "595": [48.494, -109.421],
  "145": [42.949, -77.490],
  "596": [46.550, -111.920],
  "640": [39.089, -94.221],
  "146": [43.198, -77.637],
  "597": [45.687, -112.142],
  "641": [39.119, -94.568],
  "147": [42.201, -78.865],
  "598": [47.014, -114.269],
  "148": [42.311, -77.110],
  "599": [48.317, -114.456],
  "149": [42.106, -76.819],
  "644": [40.110, -94.686],
  "645": [39.750, -94.837],
  "646": [39.868, -93.571],
  "647": [38.094, -94.216],
  "648": [36.962, -94.363],
  "649": [39.100, -94.579],
  "150": [40.469, -80.060],
  "151": [40.425, -79.935],
  "152": [40.441, -80.004],
  "153": [40.042, -80.164],
  "154": [39.953, -79.750],
  "155": [39.974, -78.888],
  "650": [38.458, -92.278],
  "156": [40.317, -79.537],
  "651": [38.570, -92.185],
  "200": [38.901, -77.020],
  "201": [38.924, -77.591],
  "157": [40.729, -79.029],
  "652": [39.184, -92.385],
  "158": [41.251, -78.709],
  "653": [38.760, -93.248],
  "202": [38.895, -77.020],
  "159": [40.356, -78.858],
  "654": [37.690, -91.815],
  "203": [38.893, -77.019],
  "655": [37.635, -91.909],
  "204": [38.895, -77.022],
  "656": [37.058, -93.123],
  "205": [38.895, -77.027],
  "700": [29.885, -90.163],
  "657": [37.061, -93.009],
  "701": [29.957, -90.070],
  "206": [38.405, -76.731],
  "658": [37.216, -93.303],
  "207": [38.912, -76.829],
  "703": [29.681, -90.777],
  "208": [39.110, -77.164],
  "704": [30.568, -90.203],
  "209": [39.014, -77.019],
  "705": [30.227, -92.124],
  "706": [30.385, -93.188],
  "707": [30.506, -91.171],
  "708": [30.477, -91.107]
};